











































import {
  computed,
  defineComponent,
  PropType,
  ref,
  toRefs
} from '~/utils/nuxt3-migration'
import AuditPackageOverview from '~/components/shared/classified/audits/AuditPackageOverview.vue'
import AuthorizedPartnerBadge from '~/components/shared/audits/badges/AuthorizedPartnerBadge.vue'
import SpotCheckBadge from '~/components/shared/audits/badges/SpotCheckBadge.vue'
import CImg from '~/components/shared/configurable/image/CImg.vue'
import { AuditAvailableProvider } from '~/models/audit/available'
import CSwipeSelector from '~/components/shared/configurable/CSwipeSelector.vue'
import { useAudits } from '~/compositions/audits'
import { defineComponentTranslations } from '~/utils/i18n'
import AuditProviderHeader from '~/components/shared/classified/audits/AuditProviderHeader.vue'
import { ciAngleLeft } from '~/icons/source/regular/angle-left'
import { useUserAgent } from '~/compositions/user-agent'

export default defineComponent({
  components: {
    AuditPackageOverview,
    AuditProviderHeader,
    CImg,
    AuthorizedPartnerBadge,
    CSwipeSelector,
    SpotCheckBadge
  },
  props: {
    selectedShopOption: {
      type: Object as PropType<AuditAvailableProvider>,
      required: true
    }
  },
  setup(props) {
    const { selectedShopOption } = toRefs(props)
    const { getUniqueOptions, getPerksPerPackage } = useAudits()
    const { isMobile } = useUserAgent()

    const isPackageExpanded = ref(false)
    const focusedIndex = ref(0)

    const selectedShop = computed(() => selectedShopOption.value.shop)

    const uniqueOptions = computed(() =>
      getUniqueOptions(selectedShopOption.value.packages)
    )

    const perksPerPackage = computed(() =>
      getPerksPerPackage(selectedShopOption.value)
    )

    return {
      selectedShop,
      isPackageExpanded,
      uniqueOptions,
      perksPerPackage,
      ciAngleLeft,
      isMobile,
      focusedIndex
    }
  },
  i18n: defineComponentTranslations({
    choose_package: {
      en: 'Choose Technical Audit package',
      el: 'Επίλεξε πακέτο Τεχνικού Ελέγχου'
    }
  })
})
